import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AdaptiveImageComponentModule } from 'ib/internetbank-core/ib-components/adaptive-image/adaptive-image.module';

import { PipeModule } from '../../common/pipes/pipe.module';
import { UiModule } from '../../ui/ui.module';

import { SplashBannerComponent } from './splash-banner/splash-banner.component';
import { SplashBannerPopUpComponent } from './splash-banner-pop-up/splash-banner-pop-up.component';

@NgModule({
	declarations: [
		SplashBannerComponent,
		SplashBannerPopUpComponent,
	],
	exports: [
		SplashBannerComponent,
		SplashBannerPopUpComponent,
	],
	imports: [
		CommonModule,
		UiModule,
		RouterModule,
		AdaptiveImageComponentModule,
		PipeModule,
	],
})
export class SplashBannersModule { }
